import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./en";

// Admin i18n foundation. English-only for the VN pilot; the CZ fork (Block 3) drops
// in a `cs` resource and switches `lng`. Imported once for its init side-effect
// (see main.tsx) before any component calls useTranslation().
i18n.use(initReactI18next).init({
  resources: { en },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
